import { generateFolderName } from "./utils/generateFolderName";
import type { NodeRequestItem } from "./utils/createNodeInput";
import { createNodesInput } from "./utils/createNodeInput";
import type { NodeApi } from "@hogartrabe/react-arborist-vrh";
import type { Folder, Node } from "interfaces/schemas";
import { NodeKinds } from "interfaces/enums";
import * as treeUtils from "utils/treeUtils";
import type { Project } from "../projectStore";
import {
  calculatePartiallyVisible,
  updateAncestorsActiveStatus,
} from "./utils";

import { processNodes } from "./utils/mutations";

export const createNode = (
  node: NodeApi,
  tree: Node[],
  project: Project,
  language: string,
) => {
  if (!project?.id) {
    throw new Error("Project ID is missing. Cannot create node.");
  }
  const newFolderName = generateFolderName(
    node.data.folderName,
    node.data.nodes,
    true,
  );

  const folderNode: Folder = {
    id: "dummy-id",
    folderName: newFolderName,
    folderDescription: "",
    parentId: treeUtils.validateNodeId(node.id, project.id),
    kind: NodeKinds.FOLDER,
    position: Array.isArray(node.data.nodes) ? node.data.nodes.length : 1,
    active: true,
    nodes: [],
    partiallyVisible: false,
  };

  const newNode = createNodesInput({
    data: folderNode,
  });

  if (newNode.error) {
    throw new Error(newNode.error.message);
  }

  if (!Array.isArray(node.data.nodes)) {
    node.data.nodes = [];
  }

  node.data.nodes.push({
    ...newNode.subTree,
    nodes: [],
    partiallyVisible: false,
  });

  if (node.isClosed) {
    node.toggle();
  }

  const nodesToUpdate: NodeRequestItem[] = [];

  const partiallyVisible = calculatePartiallyVisible(node.data);

  updateAncestorsActiveStatus(node, nodesToUpdate, project.id, {
    prev: { active: true, partiallyVisible },
  });

  processNodes(
    [
      {
        action: "CREATE",
        nodes: newNode.nodesToRequest ?? [],
      },
      {
        action: "UPDATE",
        nodes: nodesToUpdate,
      },
    ],
    project,
    language,
  );

  return [...tree];
};
